// extracted by mini-css-extract-plugin
module.exports = {"bottomAd_box":"bottomAd_box-2UhFhEvM"};